module.exports = __webpack_public_path__ + "img/Number=4.e47cefc9.png";